import { Localization } from "../../../common/localizable-component";
import { InputLocalization } from "./input-types";
import { deepmerge } from "../../../utils/deep-merge";
import { FORM_LOCALIZATION } from "../../form/constants/form-i18n";

export const INPUT_LOCALIZATION: Localization<InputLocalization> = deepmerge(FORM_LOCALIZATION, {
  en: {
    dateFormat: "MM.dd.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "en-US",
    clear: "Clear",
    showPassword: "Show password",
    hidePassword: "Hide password",
    thousandsSeparator: ","
  },
  de: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "t",
    localeMonth: "m",
    localeYear: "j",
    locale: "de-DE",
    clear: "Löschen",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
    thousandsSeparator: "."
  },
  sv: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "sv-SE",
    clear: "Rensa",
    showPassword: "Visa lösenord",
    hidePassword: "Dölj lösenord",
    thousandsSeparator: " "
  },
  nl: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "j",
    locale: "nl-NL",
    clear: "Wissen",
    showPassword: "Toon wachtwoord",
    hidePassword: "Verberg wachtwoord",
    thousandsSeparator: "."
  },
  it: {
    dateFormat: "gg.MM.aaaa",
    localeDay: "g",
    localeMonth: "m",
    localeYear: "a",
    locale: "it-IT",
    clear: "Cancella",
    showPassword: "Mostra password",
    hidePassword: "Nascondi password",
    thousandsSeparator: "."
  },
  hu: {
    dateFormat: "éééé.hh.nn.",
    localeDay: "n",
    localeMonth: "h",
    localeYear: "é",
    locale: "hu-HU",
    clear: "Töröl",
    showPassword: "Jelszó megjelenítése",
    hidePassword: "Jelszó elrejtése",
    thousandsSeparator: " "
  },
  da: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "da-DK",
    clear: "Ryd",
    showPassword: "Vis adgangskode",
    hidePassword: "Skjul adgangskode",
    thousandsSeparator: "."
  },
  fr: {
    dateFormat: "MM.jj.aaaa",
    localeDay: "j",
    localeMonth: "m",
    localeYear: "a",
    locale: "fr-FR",
    clear: "Effacer",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    thousandsSeparator: " "
  },
  es: {
    dateFormat: "MM.dd.aaa",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "a",
    locale: "es-Es",
    clear: "Borrar",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    thousandsSeparator: "."
  },
  pl: {
    dateFormat: "MM.dd.rrrr",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "r",
    locale: "pl-PL",
    clear: "Wyczyść",
    showPassword: "Pokaż hasło",
    hidePassword: "Ukryj hasło",
    thousandsSeparator: " "
  },
  ro: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "ro-RO",
    clear: "Șterge",
    showPassword: "Arată parola",
    hidePassword: "Ascunde parola",
    thousandsSeparator: "."
  },
  hr: {
    dateFormat: "MM.dd.gggg",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "g",
    locale: "hr-HR",
    clear: "Očisti",
    showPassword: "Prikaži lozinku",
    hidePassword: "Sakrij lozinku",
    thousandsSeparator: "."
  },
  cs: {
    dateFormat: "dd.MM.rrrr",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "r",
    locale: "cs-CS",
    clear: "Vymazat",
    showPassword: "Zobrazit heslo",
    hidePassword: "Skrýt heslo",
    thousandsSeparator: " "
  },
  sl: {
    dateFormat: "MM.dd.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "sl-SL",
    clear: "Počisti",
    showPassword: "Pokaži geslo",
    hidePassword: "Skrij geslo",
    thousandsSeparator: "."
  }
});
